// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"0f64964b","145":"abe3cae7","447":"2db7b800","599":"939734c2","641":"1a6fe64c","808":"96637c2e"}[chunkId] + ".chunk.css";
};